import {Component, inject, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {StoreItemActions} from "../../../store/entities/store-item/store-item.actions";
import {StoreItemEntity} from "../../../store/entities/store-item/store-item.model";
import {select, Store} from "@ngrx/store";
import {selectStoreItems} from "../../../store/entities/store-item/store-item.selectors";
import {AppState} from "../../../store/reducers";
import {Observable} from "rxjs";
import {
  PrivacyPolicyTermsCondition
} from "../../../store/entities/cms/privacy-policy-terms-condition/privacy-policy-terms-condition.model";
import {
  GET_TERMS_CONDITION
} from "../../../store/entities/cms/privacy-policy-terms-condition/privacy-policy-terms-condition.graphql";

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss']
})
export class TermsConditionsComponent implements OnInit {

  store = inject(Store<AppState>);
  privacyPolicyTermsCondition$: Observable<PrivacyPolicyTermsCondition[]>;
  title = 'Vigezo na mashariti'

  constructor(private location: Location) {
  }

  ngOnInit() {
    this.store.dispatch(StoreItemActions.getStoreItemsMergeMap({
      entity: StoreItemEntity.privacyPolicyTermsCondition,
      query: GET_TERMS_CONDITION,
      filtering: {}
    }))

    this.privacyPolicyTermsCondition$ = this.store.pipe(select(selectStoreItems(StoreItemEntity.privacyPolicyTermsCondition)))
  }

  goBack() {
    this.location.back()
  }

}
